import React, { useContext } from 'react';
import AuthContext from '../context/auth/auth-context';

const Login = (props) => {

  const authContext = useContext(AuthContext);
  const { loginUser } = authContext;

  const submitHandler = (e) => {
    e.preventDefault();
    let formData = {
      response_type: 'code',
      client_id: 'MGtFxh9EImG0KJd8ZIGR7wbl0YIpKIjL3ILxXnea',
      redirect_uri: 'https://app.paulmfitness.com:8890/fiterrapp-sso'
    }
    loginUser({
      response_type: formData.response_type,
      client_id: formData.client_id,
      redirect_uri: formData.redirect_uri
    });
  }
  
  return (
    <>
      <form onSubmit={submitHandler} >
        <input className="btn-login" type="submit" value="authorize user" />
      </form>
    </>
  )
}
  
export default Login;